/* CalmPaws interactions */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const mix = (a, b, t) => a + (b - a) * t;

  /* Header: hide on scroll down, show on scroll up */
  const header = $('[data-header]');
  let lastY = scrollY;
  const onHeader = () => {
    const y = scrollY;
    header?.classList.toggle('is-scrolled', y > 40);
    header?.classList.toggle('is-hidden', y > lastY && y > 400);
    lastY = y;
  };

  /* Reveal */
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
  }), { threshold: .15 });
  $$('.wh-rise').forEach(el => io.observe(el));

  /* Story words light up as you read */
  const story = $('[data-words]');
  let words = [];
  if (story) {
    story.innerHTML = story.textContent.trim().split(/\s+/).map(w => `<span class="w">${w}</span>`).join(' ');
    words = $$('.w', story);
  }
  const onStory = () => {
    if (!story) return;
    const r = story.getBoundingClientRect();
    const t = clamp((innerHeight * .85 - r.top) / (r.height + innerHeight * .4));
    const n = Math.round(t * words.length);
    words.forEach((w, i) => w.classList.toggle('on', i < n));
  };

  /* HERO: LOUD -> hush */
  const hero = $('[data-hero]');
  const stage = $('[data-hero-stage]');
  const loud = $('[data-loud]');
  const hush = $('[data-hush]');
  const copy = $('[data-hero-copy]');
  const after = $('[data-hero-after]');
  const bars = $$('[data-meter-bars] b');
  const num = $('[data-meter-num]');
  const meter = $('.wh-meter');
  let heroT = 0;

  const dark = [51, 40, 31], light = [232, 220, 200], lightTxt = [244, 238, 227];
  const rgb = (a, b, t) => `rgb(${a.map((v, i) => Math.round(mix(v, b[i], t))).join(',')})`;

  const onHero = () => {
    if (!hero) return;
    const r = hero.getBoundingClientRect();
    heroT = clamp(-r.top / (r.height - innerHeight));
    const t = reduce ? 1 : heroT;
    const fade = clamp((t - .15) / .55);
    stage.style.backgroundColor = rgb(dark, light, fade);
    stage.style.color = rgb(lightTxt, dark, fade);
    loud.style.opacity = 1 - clamp((t - .2) / .35);
    loud.style.filter = `blur(${clamp((t - .15) / .4) * 24}px)`;
    loud.style.transform = `scale(${mix(1, .55, clamp(t / .6))})`;
    hush.style.opacity = clamp((t - .45) / .25);
    hush.style.transform = `translateY(${mix(30, 0, clamp((t - .45) / .3))}px)`;
    copy.style.opacity = 1 - clamp(t / .3);
    after.style.opacity = clamp((t - .7) / .2);
    after.style.transform = `translateY(${mix(20, 0, clamp((t - .7) / .2))}px)`;
    after.classList.toggle('is-on', t > .75);
    const vol = Math.round(mix(100, 12, clamp(t / .8)));
    num.textContent = vol + '%';
    bars.forEach((b, i) => {
      const lvl = (i + 1) / bars.length;
      b.style.height = (6 + i * 2.4) + 'px';
      b.style.opacity = (i === 0 || lvl <= vol / 100 + .02) ? 1 : .2;
    });
    meter.style.color = vol > 40 ? 'var(--ember)' : 'var(--sage)';
    header?.classList.toggle('on-dark', fade < .5);
  };

  /* Fireworks canvas */
  const cv = $('[data-fireworks]');
  if (cv && !reduce) {
    const ctx = cv.getContext('2d');
    let W, H, dpr, parts = [], visible = true;
    const size = () => { dpr = Math.min(devicePixelRatio || 1, 2); W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    size(); addEventListener('resize', size);
    const colors = ['#E7A95B', '#F4EEE3', '#D3C0A2', '#F0C987'];
    const burst = () => {
      const x = W * (.15 + Math.random() * .7), y = H * (.12 + Math.random() * .45);
      const c = colors[(Math.random() * colors.length) | 0], n = 46 + (Math.random() * 30 | 0);
      for (let i = 0; i < n; i++) {
        const a = (i / n) * Math.PI * 2, s = 1.6 + Math.random() * 3.4;
        parts.push({ x, y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, life: 1, c });
      }
    };
    new IntersectionObserver(([e]) => visible = e.isIntersecting).observe(cv);
    let last = 0;
    const tick = now => {
      requestAnimationFrame(tick);
      if (!visible) return;
      const calm = 1 - clamp(heroT / .6);
      if (now - last > mix(1400, 260, calm) && calm > .05) { burst(); last = now; }
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = 1;
      parts = parts.filter(p => p.life > 0);
      for (const p of parts) {
        p.vx *= .985; p.vy = p.vy * .985 + .035; p.x += p.vx; p.y += p.vy; p.life -= .011;
        ctx.globalAlpha = clamp(p.life) * calm;
        ctx.fillStyle = p.c;
        ctx.beginPath(); ctx.arc(p.x, p.y, 1.8, 0, 7); ctx.fill();
      }
    };
    requestAnimationFrame(tick);
  }

  /* Product: bundle quantity + color/size -> variant */
  const root = $('[data-product]');
  const json = $('[data-product-json]');
  if (root && json) {
    const data = JSON.parse(json.textContent);
    const form = $('[data-form]', root);
    const norm = t => t.replace(/\s+/g, ' ').trim();
    const split = t => { const w = norm(t).split(' '); const size = /^(XXS|XS|S|M|L|XL|XXL|\d+)$/i.test(w[w.length - 1]) ? w.pop() : 'One size'; return { color: w.join(' ') || 'Default', size }; };
    const vs = data.variants.map(v => ({ ...v, ...split(v.title) }));
    const order = ['XXS','XS','S','M','L','XL','XXL','One size'];
    const colors = [...new Set(vs.map(v => v.color))];
    const sizes = [...new Set(vs.map(v => v.size))].sort((a, b) => order.indexOf(a) - order.indexOf(b));
    const start = vs.find(v => v.id === data.current) || vs[0];
    let color = start.color, size = start.size, firstRun = true;
    const money = cents => {
      const a = (cents / 100).toFixed(2);
      return data.money
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
        .replace(/\{\{\s*amount\s*\}\}/, a);
    };
    const pill = (name, val, group) => `<label class="wh-size"><input type="radio" name="${group}" value="${val}"><span>${val}</span></label>`;
    $('[data-colors]', root).innerHTML = colors.map(c => pill('c', c, 'wh-color')).join('');
    $('[data-sizes]', root).innerHTML = sizes.map(s => pill('s', s, 'wh-size')).join('');
    const qty = () => +($('input[name="wh-bundle"]:checked', root)?.value || 1);
    const update = () => {
      // keep size valid for chosen color
      if (!vs.some(v => v.color === color && v.size === size && v.available)) {
        const alt = vs.find(v => v.color === color && v.available); if (alt) size = alt.size;
      }
      $$('input[name="wh-color"]', root).forEach(i => i.checked = i.value === color);
      $$('input[name="wh-size"]', root).forEach(i => {
        i.checked = i.value === size;
        const ok = vs.some(v => v.color === color && v.size === i.value && v.available);
        i.disabled = !ok; i.parentElement.classList.toggle('is-off', !ok);
      });
      $('[data-color-label]', root).textContent = color;
      const v = vs.find(x => x.color === color && x.size === size);
      const atc = $('[data-atc]', root);
      if (!v || !v.available) { atc.disabled = true; $('[data-atc-label]', root).textContent = 'Sold out'; return; }
      const q = qty(), full = v.price * q, total = full - Math.round(full * (data.pct[q - 1] || 0) / 100);
      $('[data-variant-id]', root).value = v.id;
      $('[data-qty-input]', root).value = q;
      $('[data-price]', root).textContent = money(total);
      $('[data-atc-price]', root).textContent = money(total);
      const bp = $('[data-bar-price]'); if (bp) bp.textContent = money(total);
      $('[data-save]', root).textContent = total < full ? 'You save ' + money(full - total) : '';
      atc.disabled = false;
      $('[data-atc-label]', root).textContent = 'Add to cart';
      const img = $('[data-gallery-img]', root);
      if (!firstRun && img && v.img && img.src !== v.img) { img.style.opacity = 0; setTimeout(() => { img.src = v.img; img.style.opacity = 1; }, 160); }
    };
    root.addEventListener('change', e => {
      if (e.target.name === 'wh-color') color = e.target.value;
      if (e.target.name === 'wh-size') size = e.target.value;
      update();
    });
    update();
    firstRun = false;

    /* Gallery thumbs */
    $$('[data-thumb]', root).forEach(btn => btn.addEventListener('click', () => {
      const img = $('[data-gallery-img]', root); if (!img) return;
      img.style.opacity = 0;
      setTimeout(() => { img.src = btn.dataset.thumb; img.style.opacity = 1; }, 180);
      $$('[data-thumb]', root).forEach(b => b.setAttribute('aria-current', b === btn));
    }));

    /* Add to cart */
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const atc = $('[data-atc]', root), msg = $('[data-msg]', root);
      atc.disabled = true;
      try {
        const res = await fetch(WH.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +$('[data-variant-id]', root).value, quantity: qty() }] }) });
        if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart.');
        location.href = WH.cartUrl;
      } catch (err) {
        msg.textContent = err.message + ' Please try again.';
        atc.disabled = false;
      }
    });

    /* Mobile buy bar */
    const bar = $('[data-buybar]');
    $('[data-bar-atc]')?.addEventListener('click', () => form.requestSubmit());
    if (bar) new IntersectionObserver(([e]) => bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0)).observe($('[data-atc]', root));
  }

  /* Loop */
  let ticking = false;
  const onScroll = () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => { onHeader(); onHero(); onStory(); ticking = false; });
  };
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  onScroll();
})();
